import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import styles from './RewardList.css';

class GainPointItemInfo extends Component {
  render() {
    const {
      isLastRow,
      isFirstRow,
      removeGainPointItem,
      gainPointType,
    } = this.props;

    let pointAdditionalClass;
    let discountAdditionalClass;
    if (
      !removeGainPointItem &&
      !(isFirstRow && isLastRow) &&
      gainPointType === 'ITEM'
    ) {
      if (isFirstRow) {
        pointAdditionalClass = 'no-border-radius-left';
        // discountAdditionalClass = 'no-border-radius-bottom-right'
      } else if (isLastRow) {
        pointAdditionalClass = 'no-border-radius-top-left no-border-top';
        discountAdditionalClass = 'no-border-radius-top-right no-border-top';
      } else {
        pointAdditionalClass = 'no-border-radius-left no-border-top';
        discountAdditionalClass = 'no-border-radius-right no-border-top';
      }
    }

    if (
      !removeGainPointItem &&
      !(isFirstRow && isLastRow) &&
      gainPointType === 'CATEGORY'
    ) {
      if (isFirstRow) {
        pointAdditionalClass = 'no-border-radius-left no-border-radius-right';
      } else if (isLastRow) {
        pointAdditionalClass =
          'no-border-radius-top-left no-border-radius-top-right no-border-top';
      } else {
        pointAdditionalClass =
          'no-border-radius-left no-border-radius-right no-border-top';
      }
    }

    let name;
    let variant = '';
    const { itemVariantNames } = this.props;
    if (!itemVariantNames) {
      variant = 'No Variants';
    }
    if (gainPointType !== 'CATEGORY' && itemVariantNames) {
      name = this.props.itemName;
      itemVariantNames.length === 1 && itemVariantNames[0] === '*'
        ? (variant = 'All Variants')
        : itemVariantNames.forEach((element, idx) => {
            idx < this.props.itemVariantNames.length - 1
              ? (variant += `${element}, `)
              : (variant += element);
          });
    } else {
      name = this.props.categoryName;
    }

    return (
      <div>
        {gainPointType === 'CATEGORY' && (
          <div className="col-md-12">
            <div
              style={{ color: '#8e8e8e', fontWeight: '300' }}
              className={`form-control truncate ${pointAdditionalClass}`}
            >
              {name}
            </div>
          </div>
        )}
        {gainPointType !== 'CATEGORY' && (
          <div className="col-md-4 no-padding-right ">
            <div
              style={{
                borderRight: 'none',
                color: '#8e8e8e',
                fontWeight: '300',
              }}
              className={`form-control no-border-radius-right truncate ${pointAdditionalClass}`}
            >
              {name}
            </div>
          </div>
        )}
        {gainPointType !== 'CATEGORY' && (
          <div className="col-md-8 no-padding-left">
            <div
              style={{ color: '#8e8e8e', fontWeight: '300' }}
              className={`${
                removeGainPointItem ? 'has-feedback' : ''
              } truncate`}
            >
              <div
                style={{ color: '#8e8e8e' }}
                className={`form-control truncate no-border-radius-left ${discountAdditionalClass}`}
              >
                {variant}
              </div>
              {removeGainPointItem && (
                <FontAwesome
                  onClick={this._onClickRemove}
                  className={`form-control-feedback cursor-pointer ${
                    styles['remove-icon']
                  }`}
                  name="times-circle"
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  _onClickRemove = () => {
    this.props.removeGainPointItem(this.props.index);
  };
}

GainPointItemInfo.propTypes = {
  point: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

export default GainPointItemInfo;
